import { valibotResolver } from '@hookform/resolvers/valibot';
import { object } from 'valibot';

import StepDeviceInformation from '../components/StepDeviceInformation/StepDeviceInformation';
import StepGeneralDescription from '../components/StepGeneralDescription/StepGeneralDescription';
import StepPersonalInformation from '../components/StepPersonalInformation/StepPersonalInformation';
import {
  schemaDeviceInformation,
  schemaGeneralDescription,
  schemaPersonalInformation,
} from '../constants/schemaWarranty';

export const getWarrantySteps = () => {
  return [
    {
      step: 1,
      stepComponent: StepPersonalInformation,
      previousStepIndex: 'close',
      nextStepIndex: 1,
      schema: valibotResolver(schemaPersonalInformation),
    },
    {
      step: 2,
      stepComponent: StepDeviceInformation,
      previousStepIndex: 0,
      nextStepIndex: 2,
      schema: valibotResolver(schemaDeviceInformation),
    },
    {
      step: 3,
      stepComponent: StepGeneralDescription,
      previousStepIndex: 1,
      nextStepIndex: 'end',
      schema: valibotResolver(
        object({
          ...schemaPersonalInformation.entries,
          ...schemaDeviceInformation.entries,
          ...schemaGeneralDescription.entries,
        }),
      ),
    },
  ];
};
